<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="入库时间">
              <a-range-picker
                :placeholder="['开始时间', '结束时间']"
                @change="onDateChange"
                format="YYYY-MM-DD"
                v-model="queryParam.warehousingTime"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('备品备件提资入库单')" icon="download" type="primary">导出</a-button>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <dev-bpbj-warehousing-record-modal :triggerId="triggerId" @ok="modalFormOk" class="w-1300px" ref="modalForm"></dev-bpbj-warehousing-record-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DevBpbjWarehousingRecordModal from './modules/DevBpbjWarehousingRecordModal'
  import { filterObj } from '@/utils/util';

  export default {
    name: 'DevBpbjWarehousingRecordList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      DevBpbjWarehousingRecordModal
    },
    data () {
      return {
        description: '备品备件提资入库单管理页面',
        triggerId: '',
        isorter: {
          column: 'warehousingTime',
          order: 'desc'
        },
        // 表头
        columns: [

          {
            title: '入库单编码',
            align: 'center',
            dataIndex: 'warehousingCode'
          },
          {
            title: '入库时间',
            align: 'center',
            sorter: true,
            dataIndex: 'warehousingTime'
          },
          {
            title: '采购总金额',
            align: 'center',
            dataIndex: 'totalAmount'
          },

          //   {
          //     title: '提资人',
          //     align: 'center',
          //     dataIndex: 'tzrId_dictText'
          //   },

          //   {
          //     title: '验收人',
          //     align: 'center',
          //     dataIndex: 'acceptorId_dictText'
          //   },

          {
            title: '负责人',
            align: 'center',
            dataIndex: 'headId_dictText'
          },
          {
            title: '登记时间',
            align: 'center',
            dataIndex: 'registerTime',
            sorter: true,
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: '/spareparts/devBpbjWarehousingRecord/list',
          delete: '/spareparts/devBpbjWarehousingRecord/delete',
          deleteBatch: '/spareparts/devBpbjWarehousingRecord/deleteBatch',
          exportXlsUrl: '/spareparts/devBpbjWarehousingRecord/exportXls',
          importExcelUrl: 'spareparts/devBpbjWarehousingRecord/importExcel'

        },
        dictOptions: {},
        superFieldList: []
      }
    },
    created () {
      this.getSuperFieldList()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      }
    },
    methods: {
      handleAdd: function () {
        this.triggerId = null
        this.$refs.modalForm.add()
        this.$refs.modalForm.title = '新增'
        this.$refs.modalForm.disableSubmit = false
      },
      handleEdit (record) {
        this.triggerId = record.id
        this.$refs.modalForm.edit(record)
        this.$refs.modalForm.title = '编辑'
        this.$refs.modalForm.disableSubmit = false
      },
      handleDetail (record) {
        this.triggerId = record.id
        this.$refs.modalForm.edit(record)
        this.$refs.modalForm.title = '详情'
        this.$refs.modalForm.disableSubmit = true
      },
      onDateChange (value, dateString) {
        this.queryParam.warehousingTime_begin = dateString[0];
        this.queryParam.warehousingTime_end = dateString[1];
        this.searchQuery();
      },
      getQueryParams () {
        var param = Object.assign({}, this.queryParam, this.isorter);
        param.field = this.getQueryField();
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        delete param.warehousingTime; // 时间参数不传递后台
        if (this.superQueryParams) {
          param['superQueryParams'] = encodeURI(this.superQueryParams)
          param['superQueryMatchType'] = this.superQueryMatchType
        }
        return filterObj(param);
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = []
        fieldList.push({ type: 'string', value: 'warehousingCode', text: '入库单编码' })
        fieldList.push({ type: 'date', value: 'warehousingTime', text: '入库时间' })
        fieldList.push({ type: 'number', value: 'totalAmount', text: '采购总金额' })
        fieldList.push({ type: 'string', value: 'tzrId', text: '提资人' })
        fieldList.push({ type: 'string', value: 'tzrName', text: '提资人名称' })
        fieldList.push({ type: 'string', value: 'acceptorId', text: '验收人' })
        fieldList.push({ type: 'string', value: 'acceptorName', text: '验收人名称' })
        fieldList.push({ type: 'string', value: 'headId', text: '负责人' })
        fieldList.push({ type: 'string', value: 'headName', text: '负责人名称' })
        fieldList.push({ type: 'date', value: 'registerTime', text: '登记时间' })
        fieldList.push({ type: 'string', value: 'ywUnit', text: '运维单位' })
        fieldList.push({ type: 'string', value: 'warehousingStatus', text: '入库单状态' })
        fieldList.push({ type: 'string', value: 'remark', text: '备注' })
        fieldList.push({ type: 'int', value: 'delFlag', text: '删除状态' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>
